const module = { name: 'shared/global/globalTooltipModule', exports: {} }; const exports = module.exports;



import { swig as swig } from 'require-core';



import { Fandango as Fandango_globalTooltip } from 'require-core';

const { globalTooltip } = Fandango_globalTooltip;


import { Fandango_cookie as Fandango_cookie_get_getCookie_set_setCookie } from 'require-core';

const { get: getCookie, set: setCookie } = Fandango_cookie_get_getCookie_set_setCookie;


const Pages = {
    HOME: 'home',
    THEATER_SHOWTIMES: 'theaterShowtimes',
    MOVIE_OVERVIEW: 'movieOverview',
}


const Constants = {
    GLOBAL_TOOLTIP: 'globalTooltip',
    AFTEREND: 'afterend',
    AFTERBEGIN: 'afterbegin',
}


const Selectors = {
    CLOSE_BTN: '.js-global-tooltip-close-btn',
    ACTION_BTN: '.js-global-tooltip-action-btn',
    REDIRECT_LINK: '.js-global-tooltip-link',
    GLOBAL_TOOLTIP: 'global-tooltip',
    ONETRUST: 'onetrust-banner-sdk',
}


let tooltipDataId


let currentPage
function initOverlay(opts) {
    const { selector, page, overrideClass, placement, dismissOnOutsideClick, autodismiss } = opts;
    if (globalTooltip && globalTooltip.enabled && page && selector) {
        if (autodismiss) {
            const pageViewCt = Number(sessionStorage.getItem('pageViewCount'));
            sessionStorage.setItem('pageViewCount', pageViewCt + 1);
        }
        tooltipDataId = getDataId(globalTooltip);
        currentPage = page;
        const cookieExists = getTooltipCookie();
        if (cookieExists) {
            return;
        }
        const tooltipId = `${tooltipDataId}_${selector}`;
        removeTooltip(tooltipId);
        const elementReference = getElementReference(selector);
        if (elementReference) {
            const tooltipWrapper = document.createElement('div');
            tooltipWrapper.style.cssText = 'position: relative; height: 0; width: 100%; z-index: 100;';
            elementReference.insertAdjacentElement(placement ? placement : Constants.AFTEREND, tooltipWrapper);
            const { actionRenderType, actionText, headline, subheadline, tagText, webActionURL } = globalTooltip;
            const globalToolTipMarkup = swig.render('_globalTooltip', {
                inline: true,
                actionRenderType,
                actionText,
                headline,
                subheadline,
                tagText,
                webActionURL,
            });
            tooltipWrapper.innerHTML = `<div id="${tooltipId}" data-id="${tooltipDataId}" ${overrideClass ? `class="${overrideClass}"` : ''}>${globalToolTipMarkup}</div>`;
            const autodismissTooltip = autodismiss && Number(sessionStorage.getItem('pageViewCount')) > 3;
            if (autodismissTooltip) {
                dismissTooltip(tooltipId);
            }
            if (dismissOnOutsideClick) {
                const container = document.getElementById(Selectors.GLOBAL_TOOLTIP);
                document.addEventListener('mouseup', (e) => {
                    const banner = document.getElementById(Selectors.ONETRUST);
                    if (!container.contains(e.target) && (!banner || !banner.contains(e.target))) {
                        dismissTooltip(tooltipId);
                    }
                });
            }
            initDismissal(tooltipId);
        }
    }
}
function initInline(opts) {
    const { selector, page, overrideClass, placement } = opts;
    if (globalTooltip && globalTooltip.enabled && page && selector) {
        tooltipDataId = getDataId(globalTooltip);
        currentPage = page;
        const cookieExists = getTooltipCookie();
        if (cookieExists) {
            return;
        }
        const tooltipId = `${tooltipDataId}_${selector}`;
        removeTooltip(tooltipId);
        const elementReference = getElementReference(selector);
        if (elementReference) {
            const { actionRenderType, actionText, headline, subheadline, tagText, webActionURL } = globalTooltip;
            const globalToolTipMarkup = swig.render('_globalTooltip', {
                inline: true,
                actionRenderType,
                actionText,
                headline,
                subheadline,
                tagText,
                webActionURL,
            });
            const tooltip = `<div id="${tooltipId}" data-id="${tooltipDataId}" ${overrideClass ? `class="${overrideClass}"` : ''}>${globalToolTipMarkup}</div>`;
            elementReference.insertAdjacentHTML(placement ? placement : Constants.AFTEREND, tooltip);
            initDismissal(tooltipId);
        }
    }
}
function dismissTooltip() {
    const elements = document.querySelectorAll(`[data-id="${tooltipDataId}"]`);
    if (elements && elements.length > 0) {
        elements.forEach(element => element.remove());
        const cookie = getCookie(Constants.GLOBAL_TOOLTIP);
        let cookieData;
        try {
            cookieData = cookie ? JSON.parse(cookie) : {};
        }
        catch (e) {
            cookieData = {};
        }
        cookieData[currentPage] = tooltipDataId;
        setCookie(Constants.GLOBAL_TOOLTIP, JSON.stringify(cookieData), { expires: null });
    }
}
function initDismissal(tooltipId) {
    const tooltip = document.getElementById(tooltipId);
    tooltip?.querySelector(Selectors.CLOSE_BTN)?.addEventListener('click', () => {
        dismissTooltip();
    });
    tooltip?.querySelector(Selectors.ACTION_BTN)?.addEventListener('click', () => {
        dismissTooltip();
    });
    tooltip?.querySelector(Selectors.REDIRECT_LINK)?.addEventListener('click', () => {
        dismissTooltip();
    });
}
function getDataId(globalTooltip) {
    return `${globalTooltip.campaignName.toUpperCase().trim()}__${globalTooltip.version}`;
}
function getTooltipCookie() {
    const cookie = getCookie(Constants.GLOBAL_TOOLTIP);
    if (!cookie) {
        return false;
    }
    try {
        const tooltipData = JSON.parse(cookie);
        return tooltipData[currentPage] === tooltipDataId;
    }
    catch (e) {
        return false;
    }
}
function removeTooltip(tooltipId) {
    const element = document.getElementById(tooltipId);
    element?.remove();
}
function getElementReference(selector) {
    return document.querySelector(selector);
}
module.exports = {
    initOverlay,
    initInline,
    Pages,
    Constants,
};
export default module.exports;